import React from 'react'
import { Mask } from 'antd-mobile'
import styled from 'styled-components'

export interface DirectToButtonProps {
  visible: boolean
  onClose: () => void
}

const Arrow = styled.svg.attrs({
  viewBox: '2 0 32 32',
  children: <path d="M 0 5 Q 6 15 19 6 C 25 0 2 -1 9 6 Q 18 16 31 5 L 29 5 M 31 5 L 31 7" stroke="white" strokeWidth="0.3" fill="none" />
})`
  position: absolute;
  top: 5%;
  left: 50%;
  transform-origin: 0 0;
  transform: translateY(2.5rem) rotate(-30deg);
`
const Text = styled.div`
  position: absolute;
  top: 15%;
  left: 50%;
  
  color: ${props => props.theme.colors.white};
  font-size: 2rem;
  transform: translateX(-50%);
`
export const DirectToButton: React.VFC<DirectToButtonProps> = ({ visible, onClose }) => {
  return (
    <Mask visible={visible} onMaskClick={onClose} opacity="thick">
      <Arrow />
      <Text>点击进行分享</Text>
    </Mask>
  )
}
